export const IMAGES = {
  heroAbstract:
    "https://images.unsplash.com/photo-1709625862266-014ef072fd93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwYWJzdHJhY3QlMjBsaWdodHxlbnwwfHx8fDE3ODQ4NDY5OTd8MA&ixlib=rb-4.1.0&q=85",
  fogForest:
    "/manifesto.jpg",
  manifestoClean:
    "/manifesto-clean.jpg",
  marble:
    "https://images.unsplash.com/photo-1746558071208-6d7f977e82cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxzZXJlbmUlMjBtYXJibGUlMjBtb251bWVudHxlbnwwfHx8fDE3ODQ4NDY5OTd8MA&ixlib=rb-4.1.0&q=85",
  mistyWater:
    "/fidelity.jpg",
  fidelityClean:
    "/fidelity-clean.jpg",
  hands:
    "https://images.unsplash.com/photo-1590318719522-77b87d63d268?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHx0d28lMjBoYW5kcyUyMGdlbnRsZSUyMGNvbm5lY3Rpb24lMjBnZW5lcmF0aW9uc3xlbnwwfHx8fDE3ODQ4NDcwNjh8MA&ixlib=rb-4.1.0&q=85",
  windowLight:
    "https://images.unsplash.com/photo-1529047033375-f402d3da24ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxzb2Z0JTIwbGlnaHQlMjB0aHJvdWdoJTIwd2luZG93JTIwbWVtb3J5JTIwc2VyZW5lfGVufDB8fHx8MTc4NDg0NzA2OHww&ixlib=rb-4.1.0&q=85",
  stars:
    "https://images.unsplash.com/photo-1534796636912-3b95b3ab5986?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxkZWVwJTIwbmlnaHQlMjBza3klMjBzdGFycyUyMG5lYnVsYSUyMGNlbGVzdGlhbHxlbnwwfHx8YmxhY2t8MTc4NDg0ODU0NHww&ixlib=rb-4.1.0&q=85",
  celestial:
    "https://images.unsplash.com/photo-1483401757487-2ced3fa77952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxkZWVwJTIwbmlnaHQlMjBza3klMjBzdGFycyUyMG5lYnVsYSUyMGNlbGVzdGlhbHxlbnwwfHx8YmxhY2t8MTc4NDg0ODU0NHww&ixlib=rb-4.1.0&q=85",
  candlelit:
    "https://images.unsplash.com/photo-1603006905003-be475563bc59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjYW5kbGVsaXQlMjB3YXJtJTIwaW50ZXJpb3IlMjBzb2Z0JTIwZ2xvd3xlbnwwfHx8fDE3ODQ4NDg1NDR8MA&ixlib=rb-4.1.0&q=85",
  voiceEcho:
    "/voice-echo.jpg",
  voiceEchoClean:
    "/voice-echo-clean.jpg",
  ocean:
    "/pathway-memory.jpg",
  oceanClean:
    "/pathway-clean.jpg",
  garden:
    "/memory-garden.jpg",
  gardenClean:
    "/memory-garden-clean.jpg",
  emotionalPresence:
    "/emotional-presence.jpg",
  emotionalPresenceClean:
    "/emotional-presence-clean.jpg",
  seasons:
    "/seasons.jpg",
  seasonsClean:
    "/seasons-clean.jpg",
  sanctuary:
    "/sanctuary.jpg",
  sanctuaryClean:
    "/sanctuary-clean.jpg",
  digitalEstate:
    "/digital-estate.jpg",
  digitalEstateClean:
    "/digital-estate-clean.jpg",
  identityProtection:
    "/protection.jpg",
  identityProtectionClean:
    "/protection-clean.jpg",
};

export const MEMORY_NODES = [
  { id: "mother", x: 0.22, y: 0.34, label: "Mother", type: "Voice", note: "“Come home when the light turns gold.” — a voice note, kept.", links: ["childhood", "recipes"] },
  { id: "father", x: 0.72, y: 0.28, label: "Father", type: "Letter", note: "A letter written the night before your first journey away.", links: ["childhood", "sea"] },
  { id: "childhood", x: 0.45, y: 0.55, label: "Childhood", type: "Photograph", note: "Summers that smelled of cut grass and rain on warm stone.", links: ["recipes", "sea"] },
  { id: "recipes", x: 0.16, y: 0.7, label: "The Kitchen", type: "Ritual", note: "Handwritten recipes, flour-dusted, in a familiar slanting hand.", links: ["mother"] },
  { id: "sea", x: 0.83, y: 0.66, label: "The Sea", type: "Place", note: "The coast you returned to, year after year, to think.", links: ["father"] },
  { id: "wedding", x: 0.6, y: 0.8, label: "A Vow", type: "Moment", note: "Laughter caught on video, a room full of people who loved you.", links: ["childhood", "sea"] },
  { id: "grandchild", x: 0.4, y: 0.16, label: "New Light", type: "Milestone", note: "A first name spoken aloud — the future, arriving.", links: ["mother", "father"] },
];

export const EXPERIENCES = [
  {
    k: "Memory Garden",
    tag: "Living ecosystem",
    body: "Memories grow like a living landscape. Approved voice recordings become ancient trees. Shared family moments bloom into flowers. Forgotten memories drift like falling leaves. Milestones reshape the light itself.",
    img: "garden",
    imgAlt: "gardenClean",
  },
  {
    k: "Pathway Through Memory",
    tag: "Dreamlike zones",
    body: "Walk through landscapes made from approved voices, letters, photographs, and personal history. Each relationship becomes a place, including a forest, an ocean, a candlelit room, or a celestial expanse, allowing memory to be encountered through atmosphere rather than read from a screen.",
    img: "ocean",
    imgAlt: "oceanClean",
  },
  {
    k: "Voice Echo",
    tag: "Ambient sound",
    body: "Original spoken memories appear as drifting echoes in space. Verified recordings emerge gently from floating fragments and dissolve again into ambient silence. AI generated interpretation, when permitted, remains visibly distinguished from the person's original voice.",
    img: "voiceEcho",
    imgAlt: "voiceEchoClean",
  },
  {
    k: "Seasonal Reflection",
    tag: "Time & atmosphere",
    body: "The emotional atmosphere may shift across anniversaries, seasons, birthdays, and meaningful dates chosen by the individual. Memories surface through the environment itself, never through manipulative notifications or forced reengagement.",
    img: "seasons",
    imgAlt: "seasonsClean",
  },
  {
    k: "Living Legacy Sanctuary",
    tag: "For those to come",
    body: "A timeless space where future generations may explore a person's approved voice, values, stories, memories, and recorded guidance. Sacred, cinematic, and governed by the boundaries they established during life.",
    img: "sanctuary",
    imgAlt: "sanctuaryClean",
  },
  {
    k: "Emotional Presence",
    tag: "Atmosphere, not text",
    body: "With permission, EverSoul may respond to the tone of an experience through light, sound, pacing, and atmosphere. Calm memories may soften the space, reflective moments may slow it, and joyful memories may brighten the environment.",
    note: "Atmosphere responds. Identity remains protected.",
    img: "emotionalPresence",
    imgAlt: "emotionalPresenceClean",
    tall: true,
    pos: "object-[center_80%]",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Memory should not go silent.",
    body: "A photograph preserves a moment. A voice recording preserves a sound. Yet the deeper context of a person is often scattered across devices, letters, stories, and private archives. EverSoul gathers approved materials into a secure, consent governed environment designed to preserve meaning without pretending that technology can replace a human life.",
  },
  {
    n: "02",
    title: "Presence, paced with care.",
    body: "Grief has its own tempo. EverSoul respects quiet hours, moderates reengagement, and recognizes patterns that may require human support. Remembrance should support the living, never create dependence or compulsion.",
  },
  {
    n: "03",
    title: "The difference is governed intention.",
    body: "Other platforms may reproduce a face or voice. EverSoul allows the living person to determine how approved memories, values, messages, likeness, and guidance may move forward. Trustees, executors, attorneys, and designated professionals retain every legal and financial decision.",
  },
];

export const STEPS = [
  {
    tag: "Capture",
    title: "Legacy Studio",
    body: "Guided interviews, voice, writing, imagery, messages, and personal media are captured during life through explicit, revocable consent. Every approved asset is versioned and stored within the encrypted Memory Vault.",
  },
  {
    tag: "Govern",
    title: "Persona Capsule",
    body: "A signed and versioned body of approved identity references, values, communication patterns, permissions, restrictions, and provenance. Identity fidelity controls are designed to limit drift, fabrication, and unauthorized reinterpretation.",
  },
  {
    tag: "Optional Continuation",
    title: "Adaptive Companion",
    subtitle: "Optional, bounded, and consent governed",
    body: "When explicitly authorized, an AI representation may respond within the identity, source, access, and behavioral boundaries established by its owner. It always identifies itself as AI, carries provenance on every generated response, and may be restricted, paused, revoked, or prohibited entirely.",
  },
];

export const CHOICES = [
  {
    k: "Preserve",
    body: "Securely preserve approved voice, photographs, messages, writings, recordings, and memories.",
  },
  {
    k: "Share",
    body: "Give defined access to selected family members, beneficiaries, representatives, or professionals.",
  },
  {
    k: "Guide",
    body: "Deliver approved values, messages, life lessons, and milestone guidance without simulated conversation.",
  },
  {
    k: "Interact",
    body: "Permit an optional personal AI to operate only within explicit identity, content, access, and behavioral boundaries.",
  },
  {
    k: "Prohibit",
    body: "Establish a permanent instruction preventing interactive recreation of the person's voice, likeness, or identity.",
  },
];

export const PROTECTIONS = [
  "Approved uses of voice and likeness",
  "Restricted commercial or public use",
  "Authorized representatives and beneficiaries",
  "Revocation, expiration, and takedown instructions",
  "Prohibition of unauthorized impersonation or recreation",
];

export const INSTITUTIONS = [
  "Banks and trust companies",
  "Estate planning firms",
  "Family offices",
  "Insurers",
  "Wealth managers",
  "Digital asset custodians",
  "Identity protection providers",
  "AI platforms",
];

export const INHERITANCE = [
  {
    title: "Living Principal Direction",
    body: "During life, a person may define the values, guidance, educational priorities, personal milestones, and inheritance intentions they wish to carry forward. These directions become part of the governed EverSoul experience, helping future generations understand not only what was provided, but why it was provided and what the principal hoped it would make possible.",
    sub: "Legal authority remains with the applicable governing documents and designated fiduciaries.",
  },
  {
    title: "Milestone Guidance",
    body: "EverSoul may deliver the principal's approved guidance and support to beneficiaries through milestones defined during life, including reflection, educational resources, and encouragement. It may help a beneficiary understand what the principal hoped the support would accomplish and prepare documentation for human review.",
    sub: "EverSoul does not independently approve, deny, release, or distribute an inheritance.",
  },
  {
    title: "Attestation, Not Surveillance",
    body: "Where future guidance or support is connected to a documented milestone, progress may be confirmed through beneficiary supplied records or trusted third party attestations. EverSoul may organize and explain the principal's intentions, but it does not conduct covert monitoring, behavioral surveillance, or automated eligibility decisions.",
  },
  {
    title: "Human Oversight, Always",
    body: "EverSoul carries intention forward. Human fiduciaries carry authority forward. The platform may preserve, explain, and deliver the principal's approved values and guidance, while trustees, executors, attorneys, and designated professionals retain every legal and financial decision.",
    sub: "Disputes, exceptions, and final determinations are always routed to humans.",
  },
];

export const PILLARS = [
  {
    title: "Consent Architecture",
    body: "Consent is established by the individual during life and carried forward through clearly defined roles, permissions, recipient scopes, activation conditions, revocation rights, expiration instructions, and takedown procedures. Each participant receives only the access intentionally assigned to them.",
  },
  {
    title: "Encrypted Memory Vault",
    body: "Approved memories, recordings, writings, images, values, messages, permissions, and generated interactions are stored within a versioned and encrypted vault. Append only audit records preserve what was contributed, approved, changed, generated, accessed, and revoked.",
  },
  {
    title: "Identity Fidelity",
    body: "Verified identity references, approved memories, values, communication patterns, visual and voice standards, and defined boundaries help keep the representation faithful to the person it represents. Identity fidelity controls are designed to reduce drift, fabrication, impersonation, and unauthorized reinterpretation over time.",
  },
  {
    title: "Grief Sensitive Pacing",
    body: "Interaction timing, quiet hours, reengagement limits, distress signals, session pacing, and step down controls help remembrance remain supportive rather than compulsive. EverSoul preserves connection while encouraging healthy engagement with living relationships and life. Qualified human support may be recommended whenever appropriate.",
  },
  {
    title: "Truth and Provenance",
    body: "Every generated interaction clearly identifies itself as AI and shows the approved sources and permissions that allowed it to respond. Families can distinguish original recordings, verified memories, approved guidance, and AI generated interpretation.",
  },
];

export const NAV = [
  { label: "Manifesto", id: "manifesto" },
  { label: "Experience", id: "sanctuary" },
  { label: "Inheritance", id: "inheritance" },
  { label: "Governance", id: "governance" },
  { label: "About", id: "about" },
];

export const FOOTER_NAV = [
  { label: "Manifesto", id: "manifesto" },
  { label: "Experience", id: "sanctuary" },
  { label: "Inheritance", id: "inheritance" },
  { label: "Governance", id: "governance" },
  { label: "Institutional Partnerships", id: "invest" },
  { label: "About", id: "about" },
];
